import { supabase } from "./supabase";
import {
  getOtpFormDom,
  wireOtpCodeForm,
  type OtpFormDom,
} from "./otp-code-form";
import { showBoxNotice } from "./form-message-lib";
import {
  arrivedAfterSessionEnded,
  arrivedFromUnreachableServer,
} from "./session-lib";
import { setButtonBusy } from "./button-busy";

// MAIN

{
  const dom = getDomMap();
  const onSubmit = async (event: Event) => {
    event.preventDefault();
    disableForm(dom);
    setButtonBusy(dom.submitButton, true);
    const email = dom.emailInput.value;
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { shouldCreateUser: false },
    });

    // The same confirmation whether or not an account exists, which is what
    // /api/register already does: it answers 200 either way so that nobody can
    // test which addresses are registered here. The login form used to answer
    // that question for free, and in an alert carrying GoTrue's own wording
    // ("Signups not allowed for otp") at that.
    //
    // The confirmation panel carries a line for the case this costs us --
    // someone who mistyped their address and is now waiting for a mail that
    // will never arrive.
    // console.info, not error: an address without an account is an expected
    // outcome of this form, not a fault. The trace is here for debugging, and
    // the page says the same thing either way.
    if (error) console.info("magic link not sent", error);
    showSuccess(dom, email);
  };
  dom.loginForm.addEventListener("submit", (e) => void onSubmit(e));
  enableForm(dom);

  // Why the visitor is here, above the headline: the app could not check the
  // session (#442), or the server kept rejecting it (#515). The form stays
  // usable: signing in again tries again.
  const box = document.getElementById("box");
  if (box && arrivedFromUnreachableServer(window.location.search)) {
    showBoxNotice(
      box,
      "We couldn't reach the server. Check your connection and try again.",
    );
  } else if (box && arrivedAfterSessionEnded(window.location.search)) {
    showBoxNotice(box, "Your session has ended. Please sign in again.");
  }
}

// HELPER

interface DomMap {
  loginForm: HTMLFormElement;
  emailInput: HTMLInputElement;
  submitButton: HTMLButtonElement;
  success: HTMLDivElement;
  sentTo: HTMLSpanElement;
  box: HTMLDivElement;
  otpForm: OtpFormDom;
}

function getDomMap(): DomMap {
  return {
    loginForm: document.getElementById("loginForm") as HTMLFormElement,
    emailInput: document.getElementById("emailInput") as HTMLInputElement,
    submitButton: document.getElementById("submitButton") as HTMLButtonElement,
    success: document.getElementById("success") as HTMLDivElement,
    sentTo: document.getElementById("sentTo") as HTMLSpanElement,
    box: document.getElementById("box") as HTMLDivElement,
    otpForm: getOtpFormDom(),
  };
}

function disableForm(dom: DomMap) {
  dom.emailInput.disabled = true;
  dom.submitButton.disabled = true;
}

function enableForm(dom: DomMap) {
  dom.emailInput.disabled = false;
  dom.submitButton.disabled = false;
}

function showSuccess(dom: DomMap, email: string) {
  // textContent, never innerHTML: this is something a visitor typed.
  dom.sentTo.textContent = email;
  dom.success.classList.remove("invisible");
  dom.success.classList.remove("opacity-0");

  wireOtpCodeForm({
    dom: dom.otpForm,
    email,
    sentAt: Date.now(),
  });
}
